import { createAction } from "redux-actions";
export const getWalletInfo = createAction("WALLET_INFO");
export const walletControl = createAction("WALLET_CONTROL");
